'use strict';

var appTypes = require('../../types/appTypes');
var _ = require('underscore');
var interactiveType = require('../../interactive/InteractiveTypes');
var util = require('../../helper/util');

module.exports = {
  parseComInteractive: function (props) {
    var i = 0;
    var links;
    var entries;
    var result = [];
    var externalURL = props.externalURL;
    var l = 0;
    var d;
    if (props.interactiveData) {
      entries = props.interactiveData.entry;
      if (entries) {
        l = entries.length;
        for (i=0; i < l; i++) {
          if (this.isValidEntry(entries[i])) {
            result.push({entry: entries[i]});
          } else {
            result.push({});
          }
        }

      }
    }
    if (props.links && props.links.link) {
      links = props.links.link;
      l = links.length;
      for (i=0; i < l; i++) {
        if(!result[i]) {
          result[i] = {};
        }
        if (this.isValidLink(links[i])) {
          if (result[i]) {
            result[i].link = links[i];
          }
        }
      }
    }
    if (externalURL) {
      l = result.length;
      for (i; i < l; i++) {
        result[i].externalURL = externalURL;
      }
    }
    return result;
  },

  isValidLink: function (link) {
    if (link && link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK) {
      return true;
    }
    return false;
  },

  isValidEntry: function (entry) {
    if (entry && entry.events && entry.events.event && entry.events.event.length) {
      return true;
    }
    return false;
  },

  isValidExternalURL: function (url) {
    return !_.isEmpty(url);
  },

  isCanFocus: function (props) {
    var d = this.parseComInteractive(props);
    var valid = false;
    var itm;
    if (d && d.length) {
      if (d.length > 1) {
        return true;
      } else {
        itm = d[0];
      }
      valid = itm.link !== undefined || itm.entry !== undefined || itm.externalURL !== undefined;
    }
    if (!valid) {
      valid = ['ContentPanel', 'ScrollView', 'ScrollArea', 'Panel'].indexOf(props.controlTypeID) !== -1;
    }
    return valid;
  },

  hasLongPressByEntry: function (entry) {
    var r = false;
    var i;
    var event;
    if (entry && entry.events && entry.events.event) {
      for (i = 0; i < entry.events.event.length; i++) {
        event = entry.events.event[i];
        if (event.eventType === interactiveType.InteractiveTypes.EventType.LONG_PRESS) {
          r = true;
          break;
        }
      }
    }
    return r;
  },

  hasLongPressEvents: function (interactive, index) {
    var r = false;
    var entry;
    if (interactive) {
      entry = interactive.entry[index];
      return this.hasLongPressByEntry(entry);
    }
    return r;
  },

  haveAction: function (item) {        //可交互单位是否有交互数据

  },

  checkLink: function (comp) {
    var link;

    if(comp.links && comp.links.link) {
      link = comp.links.link;
      return link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK;
    }
    return false;
  },

  checkInteractive: function (entry) {
    var i;
    var j;
    var e;
    var target;
    var behavior;
    if (entry.events && entry.events.event) {
      for (i = 0; i < entry.events.event.length; i++) {
        e = entry.events.event[i];
        if (e.isChecked) {
          behavior = e.behaviour[0];
          for (j = 0; j < behavior.target.length; j++) {
            target = behavior.target[j];
            if (target && target.isChecked) {
              return true;
            }
          }
        }
      }
    }
    return false;
  },

  tranItemRect: function(str) {
    var links;
    var i;

    if(str) {
      try{
        links = JSON.parse(str);
      } catch(err) {
        console.log("error");
      }

      for(i=0;i<links.length;i++) {
        var link = links[i];
        link = util.Rect.init(link);
      }
    }
    return links;
  }
};


// WEBPACK FOOTER //
// ./src/views/common/LinkHelper.js